<mat-card>
    <mat-card-content class="justify-content-between" *ngIf="!showInvite">
        <div fxFlex="100" fxFlex.gt-md="25em" fxLayout="column" class="info">
            <mat-card-title>Your Team</mat-card-title>
            <span>Invite your team members on Arcon to work faster and collaborate easily together. Manage their
                permission to better structure projects.
            </span>
            <button mat-raised-button (click)="inviteMember()">Invite your team</button>
        </div>
        <div class="teamTable setTable">
            <div class="search">
                <mat-checkbox color="primary" [(ngModel)]="activeInactiveToggle" (change)="filterActiveInactive()">
                    Include inactive users </mat-checkbox>
                <mat-form-field appearance="outline">
                    <input matInput [ngModel]="currentSearchTerm" (ngModelChange)="applyFilter($event)"
                        placeholder="Search">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>
            <ng-container *ngIf="!isCustomer">
                <mat-table [dataSource]="myTeamList" class="internal" matSort
                    (matSortChange)="announceSortChange($event)">

                    <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
                        <mat-cell *matCellDef="let member; index as i" class="user_name"
                            [class.inActive]="!member.is_active">
                            <!-- <span class="mobile-label">Name :</span> -->
                            <logzy-img-loader src="{{member.picture==null?
                            member.gender=='Male'?base_url+'/media/profile_pics/man.svg':
                            member.gender=='Female'?base_url+'/media/profile_pics/woman.svg':
                            base_url+'/media/profile_pics/default_dp.svg':member.picture?.document_file}}"
                                border_radius="50%" [profilePic]="true" [initials]="member?.initials"
                                [class.p-0]='true'>
                            </logzy-img-loader>
                            <div class="details" fxLayout="column">
                                <span class="fw-medium">
                                    {{member?.first_name==null?"-":member?.first_name}}
                                    {{member?.last_name==null?"-":member?.last_name}}
                                </span>
                                <small>
                                    {{member?.email==null?"-":member?.email}}
                                </small>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- Weight Column -->
                    <ng-container matColumnDef="created_at">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Date Added </mat-header-cell>
                        <mat-cell *matCellDef="let member" class="fs-13" [class.inActive]="!member.is_active">
                            <span class="mobile-label">Date Added:</span>
                            {{member?.created_at==null?"-":member?.created_at | date:"dd MMM yyyy"}}
                        </mat-cell>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="last_login">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Last Active </mat-header-cell>
                        <mat-cell *matCellDef="let member" class="fs-13" [class.inActive]="!member.is_active">
                            <span class="mobile-label">Last Active:</span>
                            {{member?.last_login==null? "-" : member?.last_login | date:"dd MMM, yyyy, hh:mm"}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="approval_status">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Approval</mat-header-cell>
                        <mat-cell *matCellDef="let member" class="fs-13" [class.inActive]="!member.is_active">
                            <span class="mobile-label">Approval:</span>
                            <mat-chip>{{member?.approval_status=='pending'? 'Pending' :
                                member?.approval_status=='approved'
                                ? 'Approved' : member?.approval_status=='rejected' ? 'Rejected' : '-'}}</mat-chip>
                        </mat-cell>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                        <mat-cell *matCellDef="let member" [class.inActive]="!member.is_active">
                            <span class="mobile-label">Actions:</span>
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="viewUser(member)">
                                    <span>View Details</span>
                                </button>
                                <button mat-menu-item (click)="editUser(member)">
                                    <span>Edit Details</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
            </ng-container>
            <ng-container *ngIf="isCustomer">
                <mat-table [dataSource]="myExternalTeamList" class="external" matSort
                    (matSortChange)="announceSortChange($event)">

                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
                        <mat-cell *matCellDef="let member; index as i" class="user_name"
                            [class.inActive]="!member.is_active">
                            <logzy-img-loader
                                src="{{member?.user?.external_profile?.picture==null?
                            member?.user?.external_profile?.gender=='Male'?base_url+'/media/profile_pics/man.svg':
                            member?.user?.external_profile?.gender=='Female'?base_url+'/media/profile_pics/woman.svg':
                            base_url+'/media/profile_pics/default_dp.svg':member?.user?.external_profile?.picture?.document_file}}"
                                border_radius="50%" [profilePic]="true" [initials]="member?.user?.initials"
                                [class.p-0]='true'>
                            </logzy-img-loader>
                            <div class="details" fxLayout="column">
                                <ng-container *ngIf="member?.user==null">
                                    <span class="fw-medium">
                                        <ng-container
                                            *ngIf="(member?.first_name==null || member?.first_name=='') && (member?.last_name==null || member?.last_name=='')">
                                            Invited User
                                        </ng-container>
                                        {{member?.first_name}}
                                        {{member?.last_name}}
                                    </span>
                                    <small>
                                        {{member?.email==null?"-":member?.email}}
                                    </small>
                                </ng-container>
                                <ng-container *ngIf="member?.user!=null">
                                    <span class="fw-medium">
                                        {{member?.user?.first_name==null?"-":member?.user?.first_name}}
                                        {{member?.user?.last_name==null?"-":member?.user?.last_name}}
                                    </span>
                                    <small>
                                        {{member?.user?.email==null?"-":member?.user?.email}}
                                    </small>
                                </ng-container>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="role">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Role </mat-header-cell>
                        <mat-cell *matCellDef="let member" class="fs-13" [class.inActive]="!member.is_active">
                            {{member?.role==null?"-":member?.role?.name}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="created_at">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Date Added </mat-header-cell>
                        <mat-cell *matCellDef="let member" class="fs-13" [class.inActive]="!member.is_active">
                            {{member?.user?.external_profile?.created_at==null?"-":member?.user?.external_profile?.created_at
                            | date:"dd MMM yyyy"}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="last_login">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Last Active </mat-header-cell>
                        <mat-cell *matCellDef="let member" class="fs-13" [class.inActive]="!member.is_active">
                            {{member?.user?.last_login==null?"-":member?.user?.last_login | date:"dd MMM, yyyy, hh:mm"}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="approval_status">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
                        <mat-cell *matCellDef="let member" class="fs-13" [class.inActive]="!member.is_active">
                            <mat-chip *ngIf="member.is_active"
                                [style.background-color]="member?.user != null ? member?.user?.user_status?.color_code : '#F26331'"
                                style="color: White;">
                                {{ (member?.approval_status=='pending' && member?.user == null) ? 'Pending' :
                                (member?.approval_status =='approved' && member?.user == null) ? 'Invited' :
                                (member?.approval_status =='rejected' && member?.user == null) ? 'Rejected' :
                                member.user?.user_status.description}}
                            </mat-chip>
                            <mat-chip *ngIf="!member.is_active" style="color: White; background-color: red;">
                                Inactive
                            </mat-chip>
                            <!-- <mat-chip>
                                {{(member?.approval_status=='pending' && member?.user == null) ? 'Pending' :
                                member?.approval_status=='approved' ? 'Approved' : member?.approval_status=='rejected' ? 'Rejected' : '-'}}</mat-chip> -->
                        </mat-cell>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                        <mat-cell *matCellDef="let member" [class.inActive]="!member.is_active">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                [disabled]="!member.is_active || (member?.user == null && currentUser?.profile_role!='Admin')"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <ng-container *ngIf="member?.user != null">
                                    <button mat-menu-item (click)="viewExternalUser(member)">
                                        <span>View Details</span>
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="currentUser?.profile_role=='Admin'">
                                    <ng-container *ngIf="member?.user == null && member.approval_status == 'approved'">
                                        <button mat-menu-item (click)="openConfirmDialog('uninvite', member)">
                                            <span>Revoke Invite</span>
                                        </button>
                                    </ng-container>
                                    <ng-container>
                                        <button mat-menu-item (click)="editExternalUser(member)">
                                            <span>Edit Details</span>
                                        </button>
                                        <ng-container *ngIf="member?.approval_status =='approved'">
                                            <ng-container *ngIf="member?.user?.user_status.status_type =='1'">
                                                <button mat-menu-item (click)="openConfirmDialog('ban', member)">
                                                    <span>Ban User</span>
                                                </button>
                                            </ng-container>
                                            <ng-container *ngIf="member?.user?.user_status.status_type !='1'">
                                                <button mat-menu-item (click)="openConfirmDialog('unban', member)">
                                                    <span>Revoke Ban</span>
                                                </button>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="member?.approval_status=='pending' || member?.approval_status=='rejected'">
                                            <button mat-menu-item (click)="openConfirmDialog('approve', member)">
                                                <span>Approve</span>
                                            </button>
                                        </ng-container>
                                        <ng-container *ngIf="member?.approval_status=='pending'">
                                            <button mat-menu-item (click)="openRejectDialog(member)">
                                                <span>Reject</span>
                                            </button>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
            </ng-container>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" aria-label="Select page of my team"
                [length]="pageLength" (page)="pageChanged($event)">
            </mat-paginator>

        </div>
    </mat-card-content>
    <mat-card-content fxLayout="column" *ngIf="showInvite">
        <div fxLayout="column" class="info">

            <mat-card-title>Invite Your Teammates</mat-card-title>
            <span>Collaborate with your team to get the most out of ARCON</span>
        </div>
        <ng-container *ngIf="commonError?.email?.length">
            <span *ngFor="let error of commonError?.email">{{error}}</span>
        </ng-container>
        <div fxLayout="column" class="inviteBox">
            <div *ngFor="let item of inviteObj; let i = index" class="inviteCell">
                <!-- Email -->
                <app-text-field [isEditable]="true" [label]="'Email*'" [(ngModel)]="item.email" [name]="'email'+i"
                    [minlength]="5" fxFlex="23em" [errors]="item.error.email">
                </app-text-field>

                <!-- Role -->
                <app-mat-auto-search fxFlex="100" [isEditable]="true" [label]="'Role*'" [(ngModel)]="item.role"
                    class="m1em" fxFlex="12em" fxLayout="column" [name]="'role'+i" [displayField]="'name'"
                    [listUrl]="role_url" [idField]="null" [errors]="item.error.role">
                </app-mat-auto-search>
                <i class="flaticon-delete" *ngIf="inviteObj.length > 1" (click)="removeMember(i)"></i>
            </div>
            <div class="inviteBtn">
                <button mat-raised-button class="addBtn" (click)="addMember()">Add New Member +</button>
                <div>
                    <button mat-raised-button class="Cancel" (click)="skipInvite()">Skip</button>
                    <button mat-raised-button class="Save" [disabled]="disableInviteButton"
                        (click)="sendInvitation()">Send Invite</button>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
